import { Config } from "../../../configurations/config";
export const Timesheet_APIs = {
  GetUpdateCheckInOutTimeAPI:`${Config.server_url}${Config.api_prefix}/MyOfficeHours/CheckInCheckoutTime`,
  GetCheckInOutTimeAPI:`${Config.server_url}${Config.api_prefix}/MyOfficeHours/CheckInCheckoutTime`,
  GetSupervisorEmployees_API: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees`,
  
};
